import React from 'react';
import { Modal } from 'components';
import { useGetEmailQuery } from 'api';
import { Typography } from 'antd';
import styles from './styles.module.scss';

interface IModalProps {
  isModalOpen: boolean;
  emailId: string;
  onClose: () => void;
}

export const OriginalEmailModal = React.memo<IModalProps>((props) => {
  const { isModalOpen, emailId, onClose } = props;

  const { data: { data } = {} } = useGetEmailQuery({ id: emailId });
  return (
    <Modal
      open={isModalOpen}
      onCancel={onClose}
      title={<Typography className={styles.modal_title}>Client Original Email</Typography>}
      width={600}
      footer={null}
      closable={true}
    >
      <iframe
        srcDoc={data?.mailBodyHTML?.replace(/<a\s+(?![^>]*target=)/g, '<a target="_blank" ')}
        className={'html-content-iframe'}
        sandbox="allow-popups"
      />
    </Modal>
  );
});
